__turbopack_context__.v({
  "block": "Button-module-scss-module__aAAnma__block",
  "btn": "Button-module-scss-module__aAAnma__btn",
  "danger": "Button-module-scss-module__aAAnma__danger",
  "dark": "Button-module-scss-module__aAAnma__dark",
  "fill": "Button-module-scss-module__aAAnma__fill",
  "full": "Button-module-scss-module__aAAnma__full",
  "ghost": "Button-module-scss-module__aAAnma__ghost",
  "hug": "Button-module-scss-module__aAAnma__hug",
  "inline": "Button-module-scss-module__aAAnma__inline",
  "layout_fill": "Button-module-scss-module__aAAnma__layout_fill",
  "lg": "Button-module-scss-module__aAAnma__lg",
  "line": "Button-module-scss-module__aAAnma__line",
  "md": "Button-module-scss-module__aAAnma__md",
  "primary": "Button-module-scss-module__aAAnma__primary",
  "secondary": "Button-module-scss-module__aAAnma__secondary",
  "sm": "Button-module-scss-module__aAAnma__sm",
  "wrap": "Button-module-scss-module__aAAnma__wrap",
  "xl": "Button-module-scss-module__aAAnma__xl",
});
